export const LARGE_DL_MEMBER_COUNT: number = 100;
export const INDIVIDUAL_RECIPIENT_MEMBER_COUNT: number = 1;
